<section class="email-signup">
	@if (isSuccess()) {
	<div class="email-signup__success" role="status" aria-live="polite">
		<p>{{ successMessage() }}</p>
		<!-- <button
			type="button"
			class="email-signup__reset-btn"
			(click)="resetForm()"
			aria-label="Subscribe with another email">
			Subscribe again
		</button> -->
	</div>
	} @else {
	<form
		class="email-signup__form"
		[formGroup]="emailForm"
		(ngSubmit)="onSubmit()"
		aria-label="Email signup form">
		<div class="email-signup__input-wrapper">
			<label for="email-input" class="visually-hidden">Email address</label>
			<input
				id="email-input"
				type="email"
				formControlName="email"
				[placeholder]="placeholder()"
				class="email-signup__input"
				[class.email-signup__input--error]="emailControl.invalid && emailControl.touched"
				[attr.aria-invalid]="emailControl.invalid && emailControl.touched"
				aria-describedby="email-error"
				autocomplete="email" />
			<button
				type="submit"
				class="email-signup__submit-btn"
				[disabled]="isSubmitting()"
				[attr.aria-busy]="isSubmitting()">
				@if (isSubmitting()) {
				<span class="email-signup__spinner" aria-hidden="true"></span>
				<span class="visually-hidden">Submitting...</span>
				} @else {
				{{ buttonText() }}
				<svg
                      xmlns="https://www.w3.org/2000/svg"
                      xmlns:xlink="https://www.w3.org/1999/xlink"
					  viewBox="0 0 25 21">
                      <path fill-rule="evenodd"  fill="rgb(255, 255, 255)"
                        d="M14.306,19.418 L23.498,10.226 C23.693,10.031 24.010,10.031 24.205,10.226 C24.400,10.421 24.400,10.738 24.205,10.933 L15.013,20.126 C14.817,20.321 14.501,20.321 14.306,20.126 C14.110,19.930 14.110,19.614 14.306,19.418 Z"/>
                      <path fill-rule="evenodd"  fill="rgb(255, 255, 255)"
                        d="M15.013,0.327 L24.205,9.519 C24.400,9.714 24.400,10.031 24.205,10.226 C24.010,10.421 23.693,10.421 23.498,10.226 L14.306,1.034 C14.110,0.839 14.110,0.522 14.306,0.327 C14.501,0.132 14.817,0.132 15.013,0.327 Z"/>
                      <path fill-rule="evenodd"  fill="rgb(255, 255, 255)"
                        d="M0.834,9.708 L22.834,9.866 C23.110,9.868 23.332,10.093 23.330,10.370 C23.328,10.646 23.103,10.868 22.827,10.866 L0.827,10.708 C0.551,10.706 0.329,10.480 0.331,10.204 C0.333,9.928 0.558,9.706 0.834,9.708 Z"/>
                    </svg>
				}
			</button>
		</div>

		@if (emailControl.invalid && emailControl.touched) {
		<p id="email-error" class="email-signup__error" role="alert">
			@if (emailControl.errors?.['required']) {
			Email is required.
			} @else if (emailControl.errors?.['email']) {
			Please enter a valid email address.
			}
		</p>
		}

		@if (isError()) {
		<p class="email-signup__error email-signup__error--submit" role="alert">
			{{ errorMessage() }}
		</p>
		}
	</form>
	}
</section>
